module.exports = __webpack_public_path__ + "static/media/clover-mini-pos-device-full-service-restaurant-large.859ba60e.png";